export const WELCOME_OFFER_BONUS_PLAN_IDS = import.meta.env.VITE_WELCOME_OFFER_BONUS_PLAN_IDS ?? '19,85,91'.split(',').map(Number);